import { CourseMaterialEnum } from '@/interfaces/training.interface';
import { Icon } from '../Icon';
import { CourseDetailRowStatus } from './types';

const commonSizeIcon = {
  width: 16,
  height: 16,
};

export const getClassNamesCourseDetailRow = (
  disabled: boolean,
  className?: string
) => {
  return [
    'flex min-h-[40px] items-center justify-between gap-1 rounded-lg px-2 py-1 text-Text/LightBackground/Secondary hover:bg-Action/Hover focus-visible:border-Primary/Border active:bg-Action/DC/Selected cursor-pointer',
    disabled && '!text-Text/LightBackground/Disabled pointer-events-none',
    className,
  ].join(' ');
};

export const generateIcon = (
  materialType: CourseMaterialEnum,
  status: CourseDetailRowStatus
) => {
  if (status === 'finish')
    return (
      <Icon iconName="done" className="text-Success/Main" {...commonSizeIcon} />
    );

  if (materialType === 'Lesson')
    return <Icon iconName="record" variant="solid" {...commonSizeIcon} />;
  if (materialType === 'Quiz')
    return <Icon iconName="document-text" {...commonSizeIcon} />;
  if (materialType === 'H5P')
    return <Icon iconName="h5p-round" {...commonSizeIcon} />;

  return null;
};
